<template>
  <div>
    <div>
      <div>
        <div
          class="mb-4 ml-auto mr-auto compare-button compare-button--180"
          @click="scrollToPricing()"
        >
          <span>Compare plans</span>
        </div>
      </div>
    </div>
    <div class="sticky-wrapper" :class="activePlan" id="sticky-wrapper">
      <div class="sticky-plan-bar is-stuck" :class="activePlan">
        <div class="container sticky-bar-container">
          <div class="plans-row">
            <div class="plans-row__picker is-visible" :class="activePlan" id="plans-row-picker">
              <div
                class="compare-button compare-button--dynamic"
                @click="tooglePlanDropdown()"
              >
                <span class="mr-1.5">{{ getPlansTitle(activePlan) }}</span>
                <i class="fa fa-angle-down"></i>
              </div>
              <div class="plans-row__dropdown" :class="activePlan" id="plans-row-dropdown">
                <div class="plans-row__dropdown-triangle"></div>
                <div class="plans-row__dropdown-content">
                  <a
                    v-for="(item, index) in getPlansDropdown"
                    :key="'plan-dropdown-' + index"
                    class="leading-10 cursor-pointer"
                    data-toggle="tab"
                    @click="changePlan(item.plan)"
                    :href="'#toggle-plan-' + item.plan"
                    role="tab"
                    :aria-controls="'toggle-plan-' + item.plan"
                    aria-selected="true"
                  >
                    {{ item.title }}<br>
                  </a>
                </div>
              </div>
            </div>
            <div class="plans-row__items">
              <div
                v-for="(item, index) in getPricings"
                :key="'pricing-' + index"
                class="text-center flex-grow pt-1.25 pb-1.25 flex-basis-0"
                :class="{'plan-card--green rounded-tl-xl rounded-tr-xl' : index === 2}"
              >
                <p :class="plansRowItemHeaderTextColor[index]">
                  {{ item['label'] }}
                </p>
                <div class="flex items-center justify-center pb-1">
                  <div class="pr-1 text-sm">
                    $
                    <div style="font-size:8px">
                      US
                    </div>
                  </div>
                  <div class="flex items-center justify-center pb-1">
                    <span class="pr-1 text-2xl font-bold textPriceColor">{{ item['price'] }}</span>
                    <span class="mb-3 mr-2 text-xs font-bold textPriceColor">
                      {{ item['price'] == '0' ? '' : item['smaller-price'] }}
                    </span>
                    <div>
                      <div class="text-xs" v-if="item['price'] != '0'">
                        / {{ item['unit'] }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div
          :key="featureSectionName"
          v-for="(featuresInSection, featureSectionName) in getFeaturePlans"
        >
          <div v-if="!byPassSection.includes(featureSectionName)">
            <div class="flex">
              <div class="tc__header-title">
                {{ uppercaseSectionName(featureSectionName) }}
              </div>
              <div class="flex-grow flex-basis-0"></div>
              <div class="flex-grow flex-basis-0"></div>
              <div class="flex-grow flex-basis-0 tc__header-dummy--green"></div>
              <div class="flex-grow flex-basis-0"></div>
            </div>
            <div
              v-for="(feature, key, fIndex) in featuresInSection"
              :key="key + '-' + fIndex"
              class="flex items-stretch max-h-12 min-h-8"
              :class="getCssRowGray(fIndex)"
            >
              <div class="flex-grow text-base text-center flex-basis-0 tc__cell--feature-name">
                <span>
                  <b v-if="feature.title === 'Max. participants'">{{ feature.title }}</b>
                  <span v-else>{{ feature.title }}</span>
                  <span class="items-center tooltip">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                    <div class="tooltip-wrapper">
                      <div class="tooltip-text">
                        {{ feature.tooltipVal }}
                      </div>
                    </div>
                  </span>
                </span>
              </div>
              <div
                v-for="(item, kIndex) in feature.planVal"
                :key="key + '-' + item + '-' + kIndex"
                class="flex-grow text-center text-section-title flex-basis-0 tc__cell--feature-value"
                :class="{'tc__cell--green': kIndex === 2}"
              >
                <img
                  v-if="formatData(item) === 'correctCheck'"
                  width="20px"
                  alt="check"
                  :src="svgURL[kIndex]"
                />
                <img
                  v-else-if="formatData(item) === 'falseCheck'"
                  width="18px"
                  alt="check"
                  :src="uncheckBasic"
                />
                <span
                  v-else
                  class="font-bold"
                  :class="getCSSClassTitle(kIndex)"
                >{{ formatData(item) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container sticky-button-bar">
        <div class="flex">
          <div class="flex-grow-0 flex-shrink-0 pl-5 flex-basis-220px"></div>
          <div
            v-for="(item, index) in getUpdateLinks"
            :key="'update-link-' + index"
            class="flex-grow py-5 text-center flex-basis-0"
            :class="{'buttons-row__item--green rounded-bl-xl rounded-br-xl' : index === 2}"
          >
            <a
              v-if="item.permissionKey !== 'free'"
              @click="bottomUpgrate(item.url)"
            >
              <button
                :disabled="permission[item.permissionKey]"
                :class="actionButtonStyle[index]"
                type="button"
              > Upgrade </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Utils from '@/util'
import uncheckBasic from '@/assets/images/elements/x.svg'
import checkBasic from '@/assets/images/elements/check-gray.svg'
import checkYellow from '@/assets/images/elements/check-yellow.svg'
import checkGreen from '@/assets/images/elements/check-green.svg'
import checkPurple from '@/assets/images/elements/check-purple.svg'

export default {
  props: {
    scrollToPricing: {
      type: Function,
      default: () => {},
    },
    tooglePlanDropdown: {
      type: Function,
      default: () => {},
    },
    togglePlan: {
      type: Function,
      default: () => {},
    },
    tableData: {
      type: Object,
      default: () => {},
    },
    activePlan: {
      type: String,
      default: 'annual',
    },
    permission: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      uncheckBasic,
      svgURL: [checkBasic, checkYellow, checkGreen, checkPurple],
      plansRowItemHeaderTextColor: ['font-bold text-lg', 'font-bold text-lg text-yellow-50', 'font-bold text-lg text-green-50', 'font-bold text-lg text-purple-50'],
      actionButtonStyle: ['action-button action-button--basic', 'action-button action-button--yellow', 'action-button action-button--green', 'action-button action-button--purple'],
      byPassSection: ['updateLink', 'planPrices', 'plansDropdown'],
      dataPlansDropdown: [],
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
    getUpdateLinks() {
      return this.$props.tableData.updateLink
    },
    abTestOpenEdu() {
      return true
    },
    getPlansDropdown() {
      let plans = this.$props.tableData.plansDropdown
      if (this.abTestOpenEdu && plans) {
        plans = plans.filter((item) => {
          return item.plan !== 'educational'
        })
      }
      return plans
    },
    getPricings() {
      return this.$props.tableData.planPrices
    },
    getFeaturePlans() {
      return this.$props.tableData
    },
  },
  created() {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  mounted() {
    this.dataPlansDropdown = this.getPlansDropdown
  },
  methods: {
    bottomUpgrate(url) {
      const plan = /content=([^&]+)/.exec(url)[1] || ''
      const planType = `${plan}`
      Utils.gaTrackEvent('My plan > Upgrade > Bottom', 'Upgrade', planType)
      setTimeout(() => {
        this.$router.push(url)
      }, 500)
    },
    getPlansTitle(activePlan) {
      return `${activePlan[0].toUpperCase()}${activePlan.slice(1)} plans`
    },
    uppercaseSectionName(name) {
      return `${name[0].toUpperCase()}${name.slice(1)}`
    },
    changePlan(plan) {
      this.$props.togglePlan(plan)
    },
    formatData(data) {
      if (parseInt(data, 10)) {
        return data
      }
      return data ? 'correctCheck' : 'falseCheck'
    },
    getCSSClassTitle(index) {
      switch (index) {
        case 0:
          return 'textBasic'
        case 1:
          return 'textYellow'
        case 2:
          return 'textGreen'
        case 3:
          return 'textPurple'
        default:
          return 'textBasic'
      }
    },
    getCssRowGray(index) {
      if (index % 2 === 1) {
        return 'tc__row--gray'
      }
      return ''
    },
    handleScroll() {
      const stickyBar = document.getElementsByClassName('sticky-plan-bar')[0]
      const planPicker = document.getElementsByClassName('plans-row__picker')[0]
      const stop = stickyBar.getBoundingClientRect().top + window.scrollY - 120
      const docBody = document.documentElement || document.body.parentNode || document.body
      const hasOffset = window.pageYOffset !== undefined
      let scrollTop
      // eslint-disable-next-line prefer-const
      scrollTop = hasOffset ? window.pageYOffset : docBody.scrollTop
      if (this.activePlan === 'educational' && this.abTestOpenEdu) {
        planPicker.classList.remove('is-stuck')
        planPicker.classList.remove('is-visible')
        return
      }
      if (scrollTop >= stop) {
        stickyBar.classList.add('is-stuck')
        planPicker.classList.add('is-visible')
      } else if (scrollTop <= stop - 50) {
        planPicker.classList.remove('is-visible')
        if (stickyBar.classList.contains('is-stuck')) {
          stickyBar.classList.remove('is-stuck')
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
  .action-button {
    border-radius: 20px;
    border: 0;
    color: #fff;
    cursor: pointer;
    letter-spacing: 1px;
    text-transform: uppercase;
    transition: 0.15s linear;
  }
  @media (max-width: 479px) {
    .action-button {
      font-size: 11px;
      width: 120px;
      font-weight: bold;
    }
  }
  @media (min-width: 480px) {
    .action-button {
      font-size: 12px;
      padding: 0 20px;
      font-weight: bold;
      height: 35px;
      line-height: 37px;
    }
  }
  .text-section-title {
    font-size: 14px;
  }
  .textPriceColor {
    color: rgba(0, 0, 0, 0.6);
  }
  .textBasic {
    color: #acacac;
  }
  .textYellow {
    color: #ffae09;
  }
  .textGreen {
    color: #28c270;
  }
  .textPurple {
    color: #7669bf;
  }
  .action-button:focus {
    outline: none;
  }
  .action-button:disabled {
    cursor: not-allowed !important;
    opacity: 0.6;
  }
  .action-button--basic {
    background-color: #808080;
    border-color: #808080;
  }
  .action-button--basic:hover {
    box-shadow: 0 1px 10px rgba(128, 128, 128, 0.4);
  }
  .action-button--green {
    background-color: #28c270;
    border-color: #28c270;
  }
  .action-button--green:hover {
    box-shadow: 0 1px 10px rgba(40, 194, 112, 0.4);
  }
  .action-button--purple {
    background-color: #7669bf;
    border-color: #7669bf;
  }
  .action-button--purple:hover {
    box-shadow: 0 1px 10px rgba(118, 105, 191, 0.4);
  }
  .action-button--yellow {
    background-color: #ffae09;
    border-color: #ffae09;
  }
  .action-button--yellow:hover {
    box-shadow: 0 1px 10px rgba(255, 174, 9, 0.4);
  }
  .compare-button {
    background-color: #fff;
    color: rgba(0, 0, 0, 0.75);
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 20px;
    font-size: 16px;
    padding: 10px 0;
    -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.1);
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    cursor: pointer;
  }
  .compare-button.compare-button--180 {
    position: relative;
  }
  .compare-button.compare-button--dynamic {
    position: relative;
  }
  .compare-button.compare-button--180 .fas {
    font-size: 65%;
    position: absolute;
    right: 20px;
    top: 37%;
  }
  .compare-button.compare-button--dynamic .fas {
    font-size: 65%;
    position: absolute;
    right: 24px;
    top: 37%;
  }
  .compare-button--180 {
    width: 180px;
  }
  .compare-button--dynamic {
    width: auto;
    padding-left: 20px;
    padding-right: 34px;
  }
  .compare-button .fa {
    font-size: 16px !important;
  }
  .tooltip {
    position: relative;
  }
  .tooltip.items-center {
    z-index: unset;
    opacity: 1;
    cursor: pointer;
    padding-left: 5px;
    display: unset !important;
  }
  .tooltip.items-center.one-time-tooltip {
    padding-left: 0;
    display: unset;
  }
  .tooltip.one-time-tooltip {
    display: inline-flex;
  }
  .tooltip.tooltip.one-time-tooltip .fa {
    font-size: 18px !important;
  }
  .tooltip.items-center .fa {
    color: rgba(79, 153, 242, 0.6);
    font-size: 13px;
  }
  .tooltip:hover .tooltip-wrapper {
    visibility: visible;
    opacity: 1;
  }
  .tooltip-wrapper {
    padding-left: 20px;
    position: absolute;
    z-index: 999;
    opacity: 0;
    -webkit-transition: opacity 0.3s;
    -o-transition: opacity 0.3s;
    transition: opacity 0.3s;
    visibility: hidden;
    top: 50%;
    left: 5px;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }
  .tooltip-text {
    position: relative;
    background-color: #555;
    color: #fff;
    text-align: left;
    padding: 15px;
    border-radius: 6px;
    width: auto;
    min-width: 290px;
    max-width: 500px;
    white-space: normal;
    font-size: 13.5px;
  }
  .tooltip-text a {
    color: #fff;
    text-decoration: underline;
  }
  .tooltip-text:after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 5px 5px 5px 0;
    border-color: transparent #555 transparent transparent;
    top: 50%;
    left: 0;
    -webkit-transform: translate(-100%, -50%);
    -ms-transform: translate(-100%, -50%);
    transform: translate(-100%, -50%);
  }
  .tc__header-title {
    -ms-flex-preferred-size: 220px;
    flex-basis: 220px;
    -webkit-box-flex: 0;
    -ms-flex-positive: 0;
    flex-grow: 0;
    padding-left: 16px;
    padding-top: 2rem;
    padding-bottom: 10px;
    font-size: 16px;
    font-weight: bold;
  }
  .tc__header-dummy--green { //keep
    background-color: rgba(112, 190, 78, 0.04);
    border-left: 2px solid rgba(112, 190, 78, 0.2);
    border-right: 2px solid rgba(112, 190, 78, 0.2);
  }
  .tc__row--gray {
    background-color: rgba(0, 0, 0, 0.02);
    border-radius: 100px;
  }
  .flex-basis-0 {
    -ms-flex-preferred-size: 0;
    flex-basis: 0;
  }
  .flex-basis-220px {
    -ms-flex-preferred-size: 220px;
    flex-basis: 220px;
  }
  .max-width-220px {
    max-width: 220px;
  }
  .tc__cell--feature-name {
    max-width: 220px;
    flex-basis: 220px;
    padding: 5px 0 5px 16px;
    color: rgba(0, 0, 0, 0.6);
    text-align: left;
    white-space: pre-line;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    line-height: 18px;
  }
  .tc__cell--feature-value {
    color: rgba(0, 0, 0, 0.5);
    font-size: 15px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }
  .tc__cell--green {
    background-color: rgba(112, 190, 78, 0.04);
    border-left: 2px solid rgba(112, 190, 78, 0.2);
    border-right: 2px solid rgba(112, 190, 78, 0.2);
  }
  .plan-card--green {
    background-color: rgba(112, 190, 78, 0.04);
    border-left: 2px solid rgba(112, 190, 78, 0.2);
    border-right: 2px solid rgba(112, 190, 78, 0.2);
    border-top: 2px solid rgba(112, 190, 78, 0.2);
  }
  .plans-row {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: 0;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin: 0 auto;
  }
  .flex-grow-0 {
    -webkit-box-flex: 0;
    -ms-flex-positive: 0;
    flex-grow: 0;
  }
  .buttons-row__item--green {
    background-color: rgba(112, 190, 78, 0.04);
    border-left: 2px solid rgba(112, 190, 78, 0.2);
    border-right: 2px solid rgba(112, 190, 78, 0.2);
    border-bottom: 2px solid rgba(112, 190, 78, 0.2);
  }
  .plans-row__picker {
    -webkit-transition: opacity .3s ease;
    -o-transition: opacity .3s ease;
    transition: opacity .3s ease;
    opacity: 0;
    -ms-flex-preferred-size: 220px;
    flex-basis: 220px;
    -webkit-box-flex: 0;
    -ms-flex-positive: 0;
    flex-grow: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    position: relative;
    padding-left: 16px;
  }
  .plans-row__picker.is-visible {
    opacity: 1;
  }
  .plans-row__dropdown.is-visible {
    display: block;
  }
  .plans-row__dropdown a {
    color: inherit;
  }
  .plans-row__dropdown {
    position: absolute;
    z-index: 2;
    width: 155px;
    top: 100%;
    left: 20px;
    display: none;
    -webkit-transform: translateY(5px);
    -ms-transform: translateY(5px);
    transform: translateY(5px);
    -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    border-radius: 5px;
  }
  .plans-row__dropdown-triangle {
    width: 14px;
    height: 14px;
    position: absolute;
    -webkit-transform: rotate(45deg) translateX(-50%);
    -ms-transform: rotate(45deg) translateX(-50%);
    transform: rotate(45deg) translateX(-50%);
    top: -2px;
    -webkit-box-shadow: 0 3px 10px rgba(0, 0, 0, 0.16);
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.16);
    background-color: #fff;
    z-index: 0;
    left: 50%;
  }
  .plans-row__dropdown-content {
    background-color: #fff;
    padding-top: 10px;
    padding-bottom: 10px;
    position: relative;
    z-index: 1;
    padding-left: 20px;
  }
  .plans-row__items {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-preferred-size: 0;
    flex-basis: 0;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
  }
  .sticky-plan-bar {
    position: static;
    width: auto;
    box-shadow: none;
    background-color: #fff;
    z-index: 3;
    padding-top: 10px;
    -webkit-transition: top .3s ease;
    transition: top .3s ease;
    -moz-transition: top .3s ease;
    -ms-transition: top .3s ease;
    -o-transition: top .3s ease;
  }
  .sticky-plan-bar.is-stuck {
    position: sticky;
    width: 100%;
    box-shadow: 0 15px 5px -15px rgba(0, 0, 0, 0.2);
    top: 3.7rem;
    padding-top: 5px;
    left: 0;
  }
  .sticky-button-bar {
    -webkit-transition: 0.3s ease;
    -o-transition: 0.3s ease;
    transition: 0.3s ease;
    bottom: 0;
    z-index: 91;
    padding-bottom: 10px;
    opacity: 1 !important;
    background-color: #fff;
  }
  a {
    text-decoration: none;
    -webkit-transition-property: all;
    transition-property: all;
    -webkit-transition-duration: .3s;
    transition-duration: .3s
  }
  :focus {
    outline: 0
  }
  .tc__cell--feature-name .tooltip.flex.items-center {
    opacity: 1;
  }
  #sticky-wrapper {
    position: relative;
  }
</style>
